import { PropertyShareModel } from 'common/data/property-share/model';
import { FormPropertyShareInputInterface } from 'common/module/form/property-share/input.interface';

/**
 * Converts @props into a PropertyShareModel
 */
export class FormPropertyShareModelAdapter {
  /**
   * Converts @param input into model
   */
  public toPropertyShareModel(input: FormPropertyShareInputInterface): PropertyShareModel {
    const model = new PropertyShareModel();

    model.email = input.email.value;
    model.friend_email = input.friendEmail.value;
    model.message = input.message.value;

    if (input.captcha.value) {
      model.captcha_token = input.captcha.value;
    }

    return model;
  }
}
